import { defineComponent as i, openBlock as a, createBlock as o, unref as f, withCtx as n, createElementVNode as r } from "vue";
import m from "../SfIconBase/SfIconBase.vue.mjs";
import { SfIconSize as q } from "@storefront-ui/shared";
const d = /* @__PURE__ */ i({
  __name: "SfIconVisibilityOff",
  props: {
    size: {
      type: String,
      default: q.base
    }
  },
  setup(t) {
    return (s, e) => (a(), o(f(m), {
      size: t.size,
      viewBox: "0 0 24 24",
      "data-testid": "visibility-off"
    }, {
      default: n(() => e[0] || (e[0] = [
        r("path", { d: "m19.3 16.5-3.2-3.2q.2-.424.3-.862t.1-.938q0-1.875-1.312-3.188Q13.875 7 12 7q-.5 0-.938.1a4.3 4.3 0 0 0-.862.3L7.65 4.85a11 11 0 0 1 2.1-.638A11.6 11.6 0 0 1 12 4q3.575 0 6.425 1.887T22.7 10.8q.075.125.1.312.025.188.025.388a2 2 0 0 1-.125.7q-.574 1.275-1.437 2.375A10.5 10.5 0 0 1 19.3 16.5m-.2 5.4-3.5-3.45q-.874.275-1.762.413T12 19q-3.575 0-6.425-1.887T1.3 12.2a.8.8 0 0 1-.1-.313 3 3 0 0 1 0-.762.8.8 0 0 1 .1-.3Q1.825 9.7 2.55 8.75A13.3 13.3 0 0 1 4.15 7L2.075 4.9a.93.93 0 0 1-.275-.688q0-.412.3-.712a.95.95 0 0 1 .7-.275q.425 0 .7.275l17 17q.275.275.288.688a.93.93 0 0 1-.288.712.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275M12 16q.275 0 .512-.025.239-.025.513-.1l-5.4-5.4a3 3 0 0 0-.1.513 5 5 0 0 0-.025.512q0 1.875 1.312 3.188Q10.125 16 12 16m2.65-4.15-3-3q1.425-.225 2.325.8t.675 2.2" }, null, -1)
      ])),
      _: 1
    }, 8, ["size"]));
  }
});
export {
  d as default
};
